<div class="col-md-12 px-0 py-3">
  <div class="col-12 pb-2 d-flex">
    <h3 style=" font-weight: 700;font-size: 18px;margin-bottom: 2rem;display: flex; align-items: center;color: #313A44;">
      Change Password
    </h3>
  </div>

  <form [formGroup]="changePwdForm">
    <div class="col-xl-9 col-12">
      <div class="row">
        <!-- Filed Starts -->
        <div class="col-12 mb-3">
          <div
            [ngClass]="[changePwdForm.controls.c_pass.touched && changePwdForm.controls.c_pass.invalid ? 'custom-form inputContainer' : 'custom-form ']">
            <input [type]="showCurrPassword ? 'text' : 'password'" class="input_field px-3 pt-3" formControlName="c_pass" required
              maxlength="50" autocomplete="new-password"/>
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Current Password
              </span>
            </label>
            <button style="position: absolute;top: 9\px;right: 10px;cursor: pointer;" type="button" mat-icon-button
              class="d-inline mr-2" matSuffix (click)="showCurrPassword = !showCurrPassword" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="showCurrPassword">
              <mat-icon>{{showCurrPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
            </button>
          </div>
          <p class="mat-error m-0" *ngIf="changePwdForm.controls.c_pass.touched && changePwdForm.controls.c_pass.invalid">
            Current password is required.
          </p>
        </div>
        <!-- Field Ends -->

        <!-- Filed Starts -->
        <div class="col-12 mb-3">
          <div #passwordContainer
            [ngClass]="[changePwdForm.controls.n_pass.touched && changePwdForm.controls.n_pass.invalid ? 'custom-form inputContainer' : 'custom-form']">
            <input type="text" [value]="displayedValue" (input)="handleInput($event)" autocomplete="off" class="input_field px-3 pt-3" formControlName="n_pass" required (keypress)="mainService.handleInputSpace($event)" (focus)="showPasswordPolicyContainer()" (blur)="hidePasswordPolicyContainer()"/>
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                New Password
              </span>
            </label>
            <button style="position: absolute;top: 9\px;right: 10px;cursor: pointer;" type="button" mat-icon-button
              class="d-inline mr-2" matSuffix (click)="showNewPassword = !showNewPassword" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="showNewPassword">
              <mat-icon>{{showNewPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
            </button>
            <div class="policy__main" *ngIf="passwordPolicyContainer">
              <p style="font-weight: 600;font-size: 12px;line-height: 16px;color:#656B73;">Password must have at least:</p>
              <div class="min_length policy__common" [ngClass]="{
                 'validField': !changePwdForm.controls.n_pass.errors?.minLength,
                 'invalidField': changePwdForm.controls.n_pass.touched && changePwdForm.controls.n_pass.errors?.minLength }">
                <img src="assets/img/png/tick2.png" alt="correct" style="width: 15px;height: 15px;"
                  *ngIf="!changePwdForm.controls.n_pass.errors?.minLength" />
                <img src="assets/img/png/red_cross.png" alt="incorrect" style="width: 8px;height: 8px; margin-right: 3px;"
                  *ngIf="changePwdForm.controls.n_pass.touched && changePwdForm.controls.n_pass.errors?.minLength" />
                <span>
                  8 characters
                </span>
              </div>
              <div class="number policy__common" [ngClass]="{
               'validField': !changePwdForm.controls.n_pass.errors?.number,
               'invalidField': changePwdForm.controls.n_pass.touched && changePwdForm.controls.n_pass.errors?.number }">
                <img src="assets/img/png/tick2.png" alt="correct" style="width: 15px;height: 15px;"
                  *ngIf="!changePwdForm.controls.n_pass.errors?.number" />
                <img src="assets/img/png/red_cross.png" alt="incorrect" style="width: 8px;height: 8px; margin-right: 3px;"
                  *ngIf="changePwdForm.controls.n_pass.touched && changePwdForm.controls.n_pass.errors?.number" />
                <span>
                  1 number (0-9)
                </span>
              </div>
              <div class="lowercase policy__common" [ngClass]="{
               'validField': !changePwdForm.controls.n_pass.errors?.lowercase,
               'invalidField': changePwdForm.controls.n_pass.touched && changePwdForm.controls.n_pass.errors?.lowercase }">
                <img src="assets/img/png/tick2.png" alt="correct" style="width: 15px;height: 15px;"
                  *ngIf="!changePwdForm.controls.n_pass.errors?.lowercase" />
                <img src="assets/img/png/red_cross.png" alt="incorrect" style="width: 8px;height: 8px; margin-right: 3px;"
                  *ngIf="changePwdForm.controls.n_pass.touched && changePwdForm.controls.n_pass.errors?.lowercase" />
                <span>
                  1 lowercase letter (a-z)
                </span>
              </div>
              <div class="uppercase policy__common" [ngClass]="{
                'validField': !changePwdForm.controls.n_pass.errors?.uppercase,
                'invalidField': changePwdForm.controls.n_pass.touched && changePwdForm.controls.n_pass.errors?.uppercase }">
                <img src="assets/img/png/tick2.png" alt="correct" style="width: 15px;height: 15px;"
                  *ngIf="!changePwdForm.controls.n_pass.errors?.uppercase" />
                <img src="assets/img/png/red_cross.png" alt="incorrect" style="width: 8px;height: 8px; margin-right: 3px;"
                  *ngIf="changePwdForm.controls.n_pass.touched && changePwdForm.controls.n_pass.errors?.uppercase" />
                <span>
                  1 uppercase letter (A-Z)
                </span>
              </div>
              <div class="specialchar policy__common" [ngClass]="{
                  'validField': !changePwdForm.controls.n_pass.errors?.specialChar,
                  'invalidField': changePwdForm.controls.n_pass.touched && changePwdForm.controls.n_pass.errors?.specialChar}">
                <img src="assets/img/png/tick2.png" alt="success" style="width: 15px;height: 15px;"
                  *ngIf="!changePwdForm.controls.n_pass.errors?.specialChar" />
                <img src="assets/img/png/red_cross.png" alt="incorrect" style="width: 8px;height: 8px; margin-right: 2px;"
                  *ngIf="changePwdForm.controls.n_pass.touched && changePwdForm.controls.n_pass.errors?.specialChar" />
                <span>
                  1 special character (!&#64;#$%^&*)
                </span>
              </div>
            </div>
          </div>
          <p class="mat-error m-0"
            *ngIf="changePwdForm.controls.n_pass.touched && changePwdForm.controls.n_pass.invalid ">
            Please enter a valid password
          </p>

        </div>
        <!-- Field Ends -->

            <!-- Confirm Password Starts -->
            <div class="col-12 mb-3">
              <div
                [ngClass]="[changePwdForm.controls.rn_pass.touched && changePwdForm.controls.rn_pass.invalid ? 'custom-form inputContainer' : 'custom-form']">
                <input type="text" [value]="displayedValueConfirm" (input)="handleInputConfirm($event)" autocomplete="off" class="input_field px-3 pt-3" formControlName="rn_pass" required />
                <label for="text" [ngClass]="[changePwdForm.value.rn_pass !== '' ? 'label-name' : '']">
                  <span class="content-name f-c-p-3">
                    Confirm Password
                  </span>
                </label>
                <button style="position: absolute;top: 9\px;right: 10px;cursor: pointer;" type="button" mat-icon-button
                  class="d-inline mr-2" matSuffix (click)="showConfirmPassword = !showConfirmPassword" [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="showConfirmPassword">
                  <mat-icon>{{showConfirmPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                </button>
              </div>
              <p class="mat-error"
                *ngIf="changePwdForm.controls.rn_pass.touched && changePwdForm.controls.rn_pass.invalid">
                New password and confirm password don't match.
              </p>
            <!-- Confirm Password Ends -->
        </div>
      </div>
    </div>

    <div class="col-12 py-3">
      <button type="submit" button-primary-auth (click)="changePwd()"  class="px-4 py-0"
        style="height: 42px;" [disabled]="!changePwdForm.dirty">
        Save
      </button>
      <button button-login-secondary class="py-0 px-4 ms-2" style="height: 42px;"
        (click)="initPassword()" *ngIf="changePwdForm.dirty">
        Reset
      </button>
    </div>
  </form>
</div>
